/**
 * Supabase 客户端
 * 用于 Client Components
 */

import { createBrowserClient } from '@supabase/ssr';
import {
  HAS_SUPABASE_PUBLIC_CONFIG,
  SUPABASE_PUBLISHABLE_KEY,
  SUPABASE_URL,
} from './public-config';

const DISABLED_MESSAGE =
  '[supabase client] NEXT_PUBLIC_SUPABASE_URL / NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY is not configured. Auth features are disabled for this environment.';

let hasLoggedMissingEnvWarning = false;

function warnMissingEnv() {
  if (!hasLoggedMissingEnvWarning) {
    console.warn(DISABLED_MESSAGE);
    hasLoggedMissingEnvWarning = true;
  }
}

function createMockClient() {
  warnMissingEnv();

  const createError = () => new Error(DISABLED_MESSAGE);

  return {
    auth: {
      async getSession() {
        return { data: { session: null }, error: createError() };
      },
      async getUser() {
        return { data: { user: null }, error: null };
      },
      onAuthStateChange() {
        return {
          data: { subscription: { unsubscribe: () => {} } },
          error: null,
        };
      },
      async signOut() {
        return { error: null };
      },
      async signInWithOAuth() {
        return { data: null, error: createError() };
      },
      async signInWithOtp() {
        return { data: null, error: createError() };
      },
      async verifyOtp() {
        return { data: null, error: createError() };
      },
      async exchangeCodeForSession() {
        return { data: null, error: createError() };
      },
      async setSession() {
        return { data: null, error: createError() };
      },
    },
  } as ReturnType<typeof createBrowserClient>;
}

export function createClient() {
  if (!HAS_SUPABASE_PUBLIC_CONFIG) {
    return createMockClient();
  }

  return createBrowserClient(SUPABASE_URL!, SUPABASE_PUBLISHABLE_KEY!);
}

/**
 * 单例模式：创建全局客户端实例
 * 避免在每次渲染时创建新实例
 */
let supabaseInstance: ReturnType<typeof createClient> | null = null;

export function getClient() {
  if (!supabaseInstance) {
    supabaseInstance = createClient();
  }
  return supabaseInstance;
}
